import { useEffect } from "react";

const useSidebarOutsideClick = (sidebarRef, isOpen, setIsOpen) => {
  useEffect(() => {
    if (isOpen) return;
    const handlePointerDown = (e) => {
      if (window.innerWidth > 1024) return;
      if (sidebarRef.current?.contains(e.target)) return;
      if (e.target.closest?.("[data-sidebar-toggle]")) return;
      setIsOpen(true);
    };
    document.addEventListener("pointerdown", handlePointerDown);
    return () => document.removeEventListener("pointerdown", handlePointerDown);
  }, [isOpen, sidebarRef, setIsOpen]);
};

export default useSidebarOutsideClick;
